module.exports = __webpack_public_path__ + "static/media/284.596aaa7f.svg";